import fuse from '../../_libs/redux-fusion';
import {ReactModal} from '../../components/modals/ReactModal';
import {ReactReduxModal} from '../../core-utilities/react-redux-modals';
import {ReactReduxModalHOC} from '../../core-utilities/react-redux-modals/components/ReactReduxModalHOC';
import {VideoCallStartModalHOC, VideoCallStartModal, modalOptions} from '../components/VideoCallStartModal';
import {getVideoChatStartModal} from '../reducers/state';
import {VIDEO_CHAT_START_PREFIX} from './state';
import {logger} from './logger';


export const videoChatStartModal = new ReactReduxModal({
  prefix: VIDEO_CHAT_START_PREFIX,
  getState: getVideoChatStartModal,
  modalOptions,
  logger,
});

const StreamedComponent = VideoCallStartModalHOC({
  getModalState: getVideoChatStartModal,
});

const modalComponent = fuse(StreamedComponent)(VideoCallStartModal);

const modalConfig = {
  actions: videoChatStartModal.actions,
  getState: getVideoChatStartModal,
  logger,
};

videoChatStartModal.options.modalComponent = ReactReduxModalHOC(
  modalComponent,
  modalConfig,
  ReactModal,
);



// WEBPACK FOOTER //
// ./src/js/comments/redux/videoChatStartModal.js